.svs-chip {
  display: inline-flex;
  align-items: center;
  max-width: 270px;
  font-size: 16px;
  padding: 2px 8px 2px 16px;
  margin: 4px;
  font-family: inherit;
  text-align: left;
  background: transparent;
  outline: none;
  border-radius: 32px;
  border: 1px solid #000000;
  color: #000000;
  cursor: pointer;
  transition: 0.2s;
  &.clickable {
    &:hover {
      background-color: #e6e6e6;
    }
  }

  se-icon {
    margin: 1px -2px 1px 4px;
    font-size: 24px;
  }
}

.clickable {
  &:focus {
    border-color: #1772ed;
  }
}

.value {
  line-height: 22px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.svs-chip-read-only {
  display: inline-flex;
  align-items: center;
  max-width: 270px;
  font-size: 16px;
  font-family: inherit;
  text-align: left;
  background: transparent;
  outline: none;
  border-radius: 32px;
  border: 1px solid #9fa0a4;
  transition: 0.2s;
  opacity: 0.4;
  display: flex;
  height: 32px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.value-read-only {
  line-height: 22px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

// Align close icon on MS Edge browser.
// Will remove when Chromium-based Edge browser is released.
@supports (-ms-ime-align: auto) {
  .se-icon {
    top: 0;
  }
}

.disabled,
[disabled],
[disabled].value,
[disabled]:hover,
[disabled]:focus {
  cursor: default;
  opacity: 0.4;
}
